import { Point } from '@prodelio/components/sortable-list/Point';

export const calculateDistance = (a: Point, b: Point): number => {
  const sideX = Math.pow(a.x - b.x, 2);
  const sideY = Math.pow(a.y - b.y, 2);

  return Math.sqrt(sideX + sideY);
};
